import { useContext } from "react";
import { MessagingContext } from "./MessagingProvider";

export const useMessages = () => useContext(MessagingContext);
